module.exports = __webpack_public_path__ + "Roboto-Regular.5136cbe62a63604402f2.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/css/themes/fonts/roboto/Roboto-Regular.woff2
// module id = ../../../../../src/assets/css/themes/fonts/roboto/Roboto-Regular.woff2
// module chunks = 0